/**
 * Created by Karan variya on 22/12/2018.
 */
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { RegisterModel } from './register';
import { Register } from './reg';
import { HttpManagerService } from '../../api/httpmanager.service';
@Injectable()
export class RegisterService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    allAdmin(): Promise<RegisterModel[]> {
        return this.httpmanagerService.HttpGet('sregister', "").then(data => {
            return data.data;
        })
    }
    iAdmin(admin): Promise<Register> {
        return this.httpmanagerService.HttpPost('sregister', JSON.stringify(admin), "").then(data => {
            return data;
        })
    }
    uAdmin(id, admin): Promise<Register> {
        return this.httpmanagerService.HttpPut('sregister', JSON.stringify(admin), id).then(data => {
            return data;
        })
    }
    dAdmin(id, admin): Promise<Register> {
        return this.httpmanagerService.HttpPut('sregister/deactive', JSON.stringify(admin), id).then(data => {
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/register/register.service.ts